/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_LeadsInputs */

const en_cap_proof_leads = /** @type {(inputs: Cap_Proof_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead radar`)
};

const lv_cap_proof_leads = /** @type {(inputs: Cap_Proof_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciālo klientu radars`)
};

/**
* | output |
* | --- |
* | "Lead radar" |
*
* @param {Cap_Proof_LeadsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_leads = /** @type {((inputs?: Cap_Proof_LeadsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_LeadsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_leads(inputs)
	return en_cap_proof_leads(inputs)
});